import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21849142&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21849142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21849142')) {
      api.createRecord('21849142', component.options)
    } else {
      api.reload('21849142', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21849142&scoped=true&", function () {
      api.rerender('21849142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/PreProjectLayout/index.vue"
export default component.exports